export const measurementInMetric = () => {
  const measurements = store.getAnswers().measurements;

  if (!measurements) {
    return {};
  }

  const measurementSystem = measurements[Object.keys(measurements)[0]].name;

  const isMetric = measurementSystem === 'metric';

  return {
    age: isMetric ? getMeasurementByType('metric_age').value : getMeasurementByType('imperial_age').value,
    weight: parseInt(
      isMetric ? getMeasurementByType('weight_kg').value : getMeasurementByType('weight_lb').value / 2.205,
    ),
  };
};

function getMeasurementByType(type) {
  const measurements = store.getAnswers().measurements;

  for (let key in measurements) {
    if (measurements[key].type === type) {
      return measurements[key];
    }
  }

  return {};
}
